module.exports = __webpack_public_path__ + "img/indicator1_v2.5696ca8d.svg";